import { hasOwnProperty } from '@game/utils';
import type { FirebaseError } from 'firebase/app';

export function isFirebaseError(error: unknown): error is FirebaseError {
  return hasOwnProperty(error, 'code');
}
